import React from 'react';
import {
  AboutIcon,
  BlogIcon,
  EventIcon,
} from 'components/NewHeader/HeaderNavIcons';
import styled from 'styled-components';
import { BBPALE, BodyTextMStrong, GRAY30 } from 'global-styles';
import Link from 'next/link';
import { opacityAppear } from 'components/Home';

const CompanyNavList = () => {
  return (
    <CompanyNavListContainer>
      <ul>
        <li className="nav-item">
          <Link href="/about">
            <a>
              <span className="icon-wrapper">
                <AboutIcon />
              </span>
              <BodyTextMStrong>About</BodyTextMStrong>
            </a>
          </Link>
        </li>
        <li className="nav-item">
          <Link href="/blog">
            <a>
              <span className="icon-wrapper">
                <BlogIcon />
              </span>
              <BodyTextMStrong>Blog</BodyTextMStrong>
            </a>
          </Link>
        </li>
        <li className="nav-item">
          <Link href="/event">
            <a>
              <span className="icon-wrapper">
                <EventIcon />
              </span>
              <BodyTextMStrong>Event</BodyTextMStrong>
            </a>
          </Link>
        </li>
      </ul>
    </CompanyNavListContainer>
  );
};

export default CompanyNavList;

const CompanyNavListContainer = styled.div`
  gap: 16px;
  animation: ${opacityAppear} 0.15s ease-in;

  & a {
    display: block;
    padding: 16px;
    color: ${GRAY30};
  }
  & > ul {
    display: flex;
  }
  & a:hover {
    transition: background 0.3s;
    border-radius: 16px;
    background: ${BBPALE};
  }
  & .nav-item {
    width: 100%;
  }
  & .nav-item svg {
    margin-bottom: 8px;
  }
  .icon-wrapper {
    width: 48px;
    height: 48px;
    display: inline-block;
  }
`;
